import { EditNoteOutlined } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, Fragment } from "react";
import { IAdminUser } from "../../../interface/IAdminUser";
import { DeletePostModal } from "../modal-delete";

const rowStyles: React.CSSProperties = {
  textAlign: "center",
  padding: "10px",
  fontWeight: "bold",
};

export const DashboardTable: FC<IAdminUser> = ({
  user,
  getUserId,
  getDeleteUserId,
}) => {
  const handleUserClick = (userId: string) => {
    getUserId(userId);
  };

  const handleDeleteUser = (userId: string) => {
    getDeleteUserId(userId);
  };
  return (
    <Fragment>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={rowStyles}>Vorname</TableCell>
            <TableCell style={rowStyles}>Nachname</TableCell>
            <TableCell style={rowStyles}>Telefon</TableCell>
            <TableCell style={rowStyles}>E-Mail</TableCell>
            <TableCell style={rowStyles}>Rolle</TableCell>
            <TableCell style={rowStyles}>Aktion</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.isArray(user) &&
            user.map((itemUser) => (
              <TableRow key={itemUser._id}>
                <TableCell align="center">{itemUser.firstName}</TableCell>
                <TableCell align="center">{itemUser.lastName}</TableCell>
                <TableCell align="center">{itemUser.phone}</TableCell>
                <TableCell align="center">{itemUser.email}</TableCell>
                <TableCell align="center">
                  {itemUser.role === "employee" && "Mitarbeiter"}
                  {itemUser.role === "admin" && "Administrator"}
                  {itemUser.role === "clinic-preview" && "Klinikvorschau"}
                  {itemUser.role === "clinic-weight" && "Klinikgewicht"}
                  {itemUser.role === "clinic-dashboard" && "Klinikschachtel"}
                </TableCell>
                <TableCell align="center">
                  <Grid
                    container
                    spacing={2}
                    display="flex"
                    justifyContent="center"
                  >
                    <Grid
                      item
                      display="flex"
                      justifyContent="center"
                      alignItems="end"
                    >
                      <IconButton onClick={() => handleUserClick(itemUser._id)}>
                        <EditNoteOutlined
                          sx={{
                            fontWeight: "bold",
                            color: "black",
                          }}
                        />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <DeletePostModal
                        onDelete={() => handleDeleteUser(itemUser._id)}
                      />
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Fragment>
  );
};
